module.exports = __webpack_public_path__ + "static/media/sputnik.384ac59a.png";